<template>
  <!--编辑-->
  <div class="dialog" v-if="+dialogId === 0">
    发现尚未有版本未定版；如果要编辑历史版本，需要先将最新版本定版。 点击编辑按钮，系统会自动将最新版本定版，并以此历史版本为基准开启最新版本。
    <br />是否继续编辑？
    <div class="btn-group">
      <div class="btn" @click="cancel">取消</div>
      <div class="btn" @click="commitSave">确定</div>
    </div>
  </div>
  <!--编辑-->

  <!-- <div class="dialog" v-else-if="dialogId ===  1"></div> -->

  <!--定版本-->
  <div class="dialog" v-else-if="+dialogId === 2">
    <p>定版后，该版本的数据就不可再更改，请问是否定版？</p>
    <div class="input-item">
      <label>版本命名:</label>
      <a-textarea :rows="1" v-model="versionData.name"></a-textarea>
    </div>
    <div class="input-item">
      <label>版本log:</label>
      <a-textarea :rows="4" v-model="versionData.log"></a-textarea>
    </div>
    <div class="btn-group">
      <div class="btn" @click="cancel">取消</div>
      <div class="btn" @click="fixVersion">保存</div>
    </div>
  </div>
  <!--定版本-->

  <!--版本命名-->
  <div class="dialog" v-else-if="+dialogId === 3">
    <div class="input-item">
      <label class="ant-form-item-required">版本的新命名:</label>
      <a-textarea :rows="1" v-model="versionData.name" style="margin-left:20px"></a-textarea>
    </div>
    <div class="btn-group">
      <div class="btn" @click="cancel">取消</div>
      <div class="btn" @click="nameLogVersion('name')">保存</div>
    </div>
  </div>
  <!--版本命名-->

  <!--版本log-->
  <div class="dialog" v-else-if="+dialogId === 4">
    <div class="input-item">
      <label class="ant-form-item-required">版本更新log:</label>
      <a-textarea :rows="4" v-model="versionData.log"></a-textarea>
    </div>
    <div class="btn-group">
      <div class="btn" @click="nameLogVersion('log')">保存</div>
    </div>
  </div>
  <!--版本log-->

  <!--导出-->
  <div class="dialog" v-else-if="+dialogId === 5">
    <div class="input-item">
      <label class="ant-form-item-required">导出文档类型:</label>
      <a-select size="default" style="width: 200px" placeholder="请选择表单" value="Excel文档">
        <a-select-option v-for="(item, index) in ['Excel文档']" :key="index" :value="item">{{ item }}</a-select-option>
      </a-select>
    </div>
    <div class="input-item">
      <label class="ant-form-item-required">数据项选择:</label>
      <a-radio-group v-model="exportData.dataRange">
        <a-radio :value="0" style="display:block">全部数据项</a-radio>
        <a-radio :value="1" style="display:block">PDF报告数据范围</a-radio>
      </a-radio-group>
      <label class="ant-form-item-required" style="margin-left:40px;">数据项选择:</label>
      <a-checkbox-group v-model="exportData.checkedList" :options="['未实现部分', '已实现部分']">
        <!-- <a-checkbox style="display:block; margin-left:0" :value="0">未实现部分</a-checkbox>
        <a-checkbox style="display:block; margin-left:0" :value="1">已实现部分</a-checkbox>-->
      </a-checkbox-group>
    </div>
    <div class="input-item" v-if="+exportData.dataRange === 1">
      <label class="ant-form-item-required">报告文字:</label>
      <a-radio-group v-model="exportData.dataLanguage">
        <a-radio :value="0" style="display:block">中文报告</a-radio>
        <a-radio :value="1" style="display:block">English report</a-radio>
      </a-radio-group>
    </div>
    <div class="btn-group-antd">
      <a-button class="btn" type="primary" @click="cancel">取消</a-button>
      <a-button class="btn" type="primary" @click="exportFile" :loading="exportLoading">导出</a-button>
    </div>
  </div>
  <!--导出-->

  <!--版本对比-->
  <div class="dialog" v-else-if="+dialogId === 6">
    <div style="margin-bottom: 20px;" class="ant-form-item-required">请选择需要对比的文档</div>
    <div class="select-group" v-if="compareData.tableList.length > 0">
      <div class="input-item">
        <a-select
          size="default"
          style="width: 200px"
          placeholder="报表"
          v-if="compareData.selectedTable && compareData.selectedTable.name"
          :value="compareData.selectedTable.name"
        >
          <a-select-option v-for="(item, index) in compareData.tableList" :key="index" :value="item.name" @click="selectCompareTable(item)">
            {{ item.name }}
          </a-select-option>
        </a-select>
        <a-select
          size="default"
          style="width: 100px; margin-left: 50px;"
          placeholder="版本"
          v-if="compareData.selectedVersion && compareData.selectedVersion.version"
          :value="compareData.selectedVersion.version"
        >
          <a-select-option v-for="(item, index) in compareData.versionList" :key="index" :value="item.version" @click="selectCompareVersion(item)">
            {{ item.version }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div>
      1、点击下方对比按钮后，会将当前版本和上面版本报表进行比较，将不同项
      <span style="color:red;">飘红</span>，若要取消飘红效果，请点击取消对比按钮（在原位置） <br />2、将鼠标放在数据项上，会显示两个版本在该数据项中的数值；
    </div>
    <div class="btn-group">
      <div class="btn" @click="cancel">取消</div>
      <div class="btn" @click="versionCompare">对比</div>
    </div>
  </div>
  <!--版本对比-->

  <!--新建-->
  <div class="dialog" v-else-if="+dialogId === 7">
    <div class="input-item">
      上次报表截止日期：
      <span v-if="newAndRefreshData.lastEndDate">{{ newAndRefreshData.lastEndDate }}</span>
      <span v-else>无</span>
    </div>
    <div class="input-item ant-form-item-required">
      本次报表日期区间：
      {{ newAndRefreshData.thisStartDate }}
      <span style="margin:0 20px;">~</span>
      <a-date-picker
        v-model="newAndRefreshData.thisEndDate"
        @change="newAndRefreshData.refresh += 1"
        :disabledDate="cannotExceedTomorrow"
        style="cursor:pointer"
        format="YYYY.MM.DD"
      />
    </div>
    <div class="input-item ant-form-item-required">
      新建报表名称：
      <a-input style="width: 330px;" placeholder="如：20XX年QX-汇总表" v-model="newAndRefreshData.name" />
    </div>
    <div class="btn-group">
      <a-button class="btn" @click="cancel">取消</a-button>
      <a-button class="btn" @click="submitNew" :loading="newFairLoading">新建</a-button>
    </div>
  </div>
  <!--新建-->

  <!--刷新-->
  <div class="dialog" v-else-if="+dialogId === 8">
    <div class="input-item">
      上次报表截止日期：
      <span v-if="newAndRefreshData.lastEndDate">{{ newAndRefreshData.lastEndDate }}</span>
      <span v-else>无</span>
    </div>
    <div class="input-item">
      本次报表日期区间：
      {{ newAndRefreshData.thisStartDate }}
      <span style="margin:0 20px;">~</span>
      {{ newAndRefreshData.thisEndDate }}
    </div>
    <!-- <div class="input-item">
      报表名称：
      <a-input style="width: 330px;" v-model="newAndRefreshData.name" />
    </div>-->
    <div class="center-btn" @click="getCompareData">
      <a-button class="center-btn" :loading="this.newAndRefreshData.refreshLoading" style="width: 100%; height: 100%;">获取最新数据</a-button>
    </div>
    <compare
      ref="refreshCompareData"
      style="margin-top: 20px"
      v-if="newAndRefreshData.compareVisible"
      :compareInfo="newAndRefreshData"
      :refresh="newAndRefreshData.refresh"
      :fundInfoFlag="tableInfo.fundInfoFlag"
      type="1"
      @submitCheckIds="submitCheckIds"
      @switchRefreshFlag="switchRefreshFlag"
    ></compare>
    <div v-if="newAndRefreshData.compareVisible" class="ant-form-item-required" style="margin-top: 10px;">
      请勾选需要导入的变化数据；上面未勾选数据，不会导入到系统中
    </div>
    <div class="btn-group-antd" v-if="newAndRefreshData.compareVisible">
      <a-button class="btn" type="primary" @click="cancel">取消</a-button>
      <a-button class="btn" type="primary" @click="submitRefresh" :loading="refeshSubmitLoading">确定</a-button>
    </div>
  </div>
  <!--刷新-->

  <!--预测表-->
  <div class="dialog" v-else-if="+dialogId === 9">
    <div style="margin-bottom: 20px;">将以现有版本公允价值表数据，来生成预测表</div>
    <div class="input-item">
      <label class="ant-form-item-required" style="margin-right: 20px">新建报名表名称</label>
      <a-textarea :rows="1" v-model="forecastData.name" style="width:200px;"></a-textarea>
    </div>
    <div>生成预测表后，请手动进行调整</div>
    <div class="btn-group">
      <div class="btn" @click="cancel">取消</div>
      <div class="btn" @click="newForecast">新建</div>
    </div>
  </div>
  <!--预测表-->

  <!--发布-->
  <div class="dialog gap-mix" v-else-if="+dialogId === 10">
    <h3>发布后,有些项目审核时间将更新,历史切片数据将不能修改,是否确定发布?</h3>
    <div class="list">
      <div class="audited">
        <p>
          发布后,完成审核的项目为: <br />
          <span class="hint">&nbsp;</span>
        </p>
        <a-table :columns="columnsAudited" :data-source="dataAudited" :pagination="false" :scroll="{ y: 400 }">
          <span slot="auditTime" slot-scope="text">{{ text ? '截止' + text + '前' : '暂无' }}</span>
        </a-table>
      </div>
      <div class="unaudited">
        <p>
          未完成审核的项目为: <br />
          <span class="hint">待发布基金包括所有投过项目的主基金/专项基金、父主基金/专项基金</span>
        </p>
        <a-table :columns="columnsUnAudited" :data-source="dataUnAudited" :pagination="false" :scroll="{ y: 400 }">
          <span slot="auditTime" slot-scope="text">{{ text ? '截止' + text + '前' : '暂无' }}</span>
          <div slot="fundList" slot-scope="text">
            <div v-for="i in text" :key="i.message">
              <a-tooltip>
                <template slot="title"> {{ i.publishDate ? i.publishDate : '暂无' }}-{{ i.name }} </template>
                <div class="fund-list">
                  <span style="display:inline-block;width: 60px;color:">{{ i.publishDate ? i.publishDate : '暂无' }}</span>
                  {{ i.name }}
                </div>
              </a-tooltip>
            </div>
          </div>
        </a-table>
      </div>
    </div>
    <div class="btn-group gap-12">
      <div class="btn" @click="cancel">取消</div>
      <div class="btn" :class="{ disabled: !canPublish }" @click="publish">发布</div>
    </div>
  </div>
  <!--发布-->

  <!--系统校验-->
  <div class="dialog" v-else-if="+dialogId === 11">
    此功能主要用于校验法务系统中数据和财务公允价值表中的数据不一致情况
    <br />
    <br />
    <!-- 
    <br />点击下方【发邮件】按钮后会将上述校验报告邮件发送给该email地址
    <br />
    <a-textarea style="width: 100%; margin: 20px 0" placeholder="请填写需要接收上述校验报告的邮件地址，多个邮件请用,分隔" />-->
    <a-select size="default" style="width: 400px" placeholder="请选择基金" :value="systemCheckData.selectedFund.name" v-if="systemCheckData.fundList.length">
      <a-select-option v-for="(item, index) in systemCheckData.fundList" :key="index" :value="item.name" @click="selectFund(item)">
        {{ item.name }}
      </a-select-option>
    </a-select>
    <div class="btn-group">
      <div class="btn" @click="cancel">取消</div>
      <div class="btn" @click="submitSystemCheck">校验</div>
    </div>
  </div>
  <!--系统校验-->

  <!--表单更名-->
  <div class="dialog" v-else-if="+dialogId === 13">
    <div class="input-item">
      <label>表单现用名:</label>
      <span style="margin-left:20px">{{ tableInfo.selectedTable.name }}</span>
    </div>
    <div class="input-item">
      <label class="ant-form-item-required">更名为:</label>
      <a-input style="margin-left:20px" placeholder="输入表单要更改的名字" v-model="renameData.name" />
    </div>
    <div class="btn-group">
      <div class="btn" @click="cancel">取消</div>
      <div class="btn" @click="renameFair()">保存</div>
    </div>
  </div>
  <!--表单更名-->
  <!--美元ir导出-->
  <div class="dialog" v-else-if="+dialogId === 14">
    <div class="input-item">
      <label>请确认导出IR大表</label>
      <!-- <a-radio-group v-model="exportIrData.type">
        <a-radio :value="0" style="display:block">美元IR</a-radio>
        <a-radio :value="1" style="display:block">人民币IR</a-radio>
      </a-radio-group> -->
    </div>
    <div class="btn-group-antd">
      <a-button class="btn" type="primary" @click="cancel">取消</a-button>
      <a-button class="btn" type="primary" @click="exportIr" :loading="exportIrLoading">导出</a-button>
    </div>
  </div>
  <!--美元ir导出-->
</template>
<script>
import downloadStreamFile from 'assets/js/downloadStreamFile';
import moment from 'moment';
import { queryFairCommon, queryFundList, queryVersionDetail, queryLastDate, saveByRefresh, newFair, companyAuditUpdateList } from '@/api/finance';
import compare from './compare.vue';

const columnsAudited = [
  {
    title: '项目名称',
    dataIndex: 'companyName',
    key: 'companyName',
    ellipsis: true
  },
  {
    title: '项目审核时间将更新至',
    dataIndex: 'auditTime',
    key: 'auditTime',
    scopedSlots: { customRender: 'auditTime' }
  }
];

const columnsUnAudited = [
  {
    title: '项目名称',
    width: '25%',
    dataIndex: 'companyName',
    key: 'companyName',
    ellipsis: true
  },
  {
    title: '项目审核时间',
    width: '25%',
    dataIndex: 'auditTime',
    key: 'auditTime',
    scopedSlots: { customRender: 'auditTime' }
  },
  {
    title: '报表截止日期-基金名称',
    dataIndex: 'fundList',
    key: 'fundList',
    scopedSlots: { customRender: 'fundList' },
    ellipsis: true
  }
];

const dataAudited = [];
const dataUnAudited = [];

export default {
  data() {
    return {
      exportData: {
        dataRange: 0, //0 全部数据项 1 pdf 2 已实现部分
        dataLanguage: 0, //0 中文 1 pdf英文 2 pdf中文
        checkedList: ['未实现部分', '已实现部分']
      },
      exportIrData: {
        type: 0 //0 美元ir 1 人民币ir
      },
      compareData: {
        refresh: 0,
        visible: false,
        selectedTable: null,
        selectedVersion: null,
        tableList: [],
        versionList: []
      },
      newAndRefreshData: {
        refresh: 0,
        itemId: null,
        name: '',
        fundName: '',
        visible: false,
        lastEndDate: null,
        thisStartDate: null,
        thisEndDate: null,
        compareData: [],
        compareVisible: false,
        receivedIds: [],
        refreshLoading: false
      },
      versionData: {
        name: '',
        log: ''
      },
      forecastData: {
        name: ''
      },
      systemCheckData: {
        fundList: [],
        selectedFund: {}
      },
      renameData: {
        name: ''
      },
      columnsAudited: columnsAudited,
      columnsUnAudited: columnsUnAudited,
      dataAudited: dataAudited,
      dataUnAudited: dataUnAudited,
      canPublish: false,
      newFairLoading: false,
      exportLoading: false,
      exportIrLoading: false,
      refeshSubmitLoading: false
    };
  },
  props: {
    dialogId: {
      type: Number
    },
    versionId: {
      type: Number
    },
    //versionId即为tableInfo.selectedTable.id
    tableInfo: {
      type: Object
    }
  },
  computed: {},
  watch: {
    dialogId: {
      handler: function(val, oldVal) {
        if (val !== oldVal) {
          this.handleMenu(val);
        }
      },
      immediate: true
    }
  },
  components: {
    compare
  },
  created() {},
  mounted() {},
  methods: {
    cannotExceedTomorrow(time) {
      return time > moment(new Date());
    },
    handleMenu(dialogId) {
      // console.log("dialogId", dialogId);
      if (+dialogId === 6) {
        queryFairCommon({
          fairId: this.tableInfo.selectedTable.id
        }).then(res => {
          const data = res.data;
          this.compareData.tableList = res.data;

          // 如果this.tableInfo.selectedVersion.type >=2,则过滤compareData.tableList中VersionList的type>=2的数据
          if (this.tableInfo.fundInfoFlag >= 2) {
            this.compareData.tableList.forEach(item => {
              item.versionList = item.versionList.filter(version => version.type >= 2);
            });
            this.compareData.tableList = this.compareData.tableList.filter(item => {
              return item.versionList.length > 0;
            });
          } else {
            this.compareData.tableList.forEach(item => {
              item.versionList = item.versionList.filter(version => version.type === 0 || version.type === 1);
            });
            this.compareData.tableList = this.compareData.tableList.filter(item => {
              return item.versionList.length > 0;
            });
          }
          this.compareData.selectedTable = data.filter(fairTable => {
            return +this.tableInfo.selectedTable.id === +fairTable.id;
          })[0];
          this.compareData.versionList = this.compareData.selectedTable['versionList'];
          this.compareData.selectedVersion = this.compareData.versionList[0];
        });
      } else if ([2, 3, 4].includes(dialogId)) {
        queryVersionDetail({
          versionId: this.tableInfo.selectedVersion.id
        }).then(res => {
          const data = res.data;
          this.versionData.name = data.name;
          this.versionData.log = data.log;
        });
      } else if (+dialogId === 8) {
        //刷新
        this.newAndRefreshData.lastEndDate = moment(this.tableInfo.selectedTable.startDate)
          .add(-1, 'days')
          .format('YYYY.MM.DD');
        this.newAndRefreshData.itemId = this.tableInfo.selectedVersion.id;
        this.newAndRefreshData.thisStartDate = this.tableInfo.selectedTable.startDate;
        this.newAndRefreshData.thisEndDate = this.tableInfo.selectedTable.endDate;
      } else if (+dialogId === 7) {
        //新建
        queryLastDate({
          entityId: this.tableInfo.fundId
        }).then(res => {
          const data = res.data;
          if (data.haveDate) {
            this.newAndRefreshData.lastEndDate = moment.unix(data.lastDate).format('YYYY.MM.DD');
          } else {
            this.newAndRefreshData.lastEndDate = null;
            this.newAndRefreshData.thisStartDate = '最早交易记录';
          }
          this.newAndRefreshData.fundName = this.tableInfo.fundName;
          this.newAndRefreshData.itemId = this.tableInfo.fundId;
          this.newAndRefreshData.thisEndDate = moment();
        });
      } else if (+dialogId === 10) {
        this.getAuditUpdate();
      } else if (+dialogId === 11) {
        queryFundList().then(res => {
          const data = res.data;
          this.systemCheckData.fundList = data;
        });
      }
    },
    getCompareData() {
      if (this.newAndRefreshData.refreshLoading) {
        return;
      }
      this.newAndRefreshData.refreshLoading = true;
      this.newAndRefreshData.compareVisible = true;
      this.newAndRefreshData.refresh += 1;
      // console.log("getCompareData", this.newAndRefreshData);
    },
    cancel() {
      this.$emit('cancel');
    },
    /**edit-save */
    commitSave() {
      this.$emit('confirm', {
        event: 'edit-save'
      });
    },
    /**edit-save */
    /**compare */
    versionCompare() {
      this.$emit('confirm', {
        event: 'compare',
        compare: true,
        versionId: this.compareData.selectedVersion.id
      });
    },
    selectCompareTable(item) {
      this.compareData.selectedTable = item;
      this.compareData.versionList = item.versionList;
      this.compareData.selectedVersion = item.versionList[0];
    },
    selectCompareVersion(item) {
      this.compareData.selectedVersion = item;
    },
    /**compare */
    /**fixVersion */
    fixVersion() {
      this.$emit('confirm', {
        event: 'fix-version',
        name: this.versionData.name || '-',
        log: this.versionData.log || '-'
      });
    },
    /**fixVersion */
    /**nameVersion */
    nameLogVersion(type) {
      if (type === 'name' && !this.versionData.name) {
        this.$message.error('请填写版本名称');
      } else if (type === 'log' && !this.versionData.log) {
        this.$message.error('请填写版本log');
      } else {
        this.$emit('confirm', {
          event: 'name-log-version',
          name: this.versionData.name,
          log: this.versionData.log
        });
      }
    },
    /**nameVersion */
    exportFile() {
      try {
        this.exportLoading = true;
        let dataItem, dataRange;
        if (this.exportData.checkedList.length === 0) {
          this.$message.error('数据项至少选择一项');
          return;
        } else if (this.exportData.checkedList.length === 2) {
          dataRange = 0;
        } else if (this.exportData.checkedList[0] === '未实现部分') {
          dataRange = 1;
        } else if (this.exportData.checkedList[0] === '已实现部分') {
          dataRange = 2;
        }
        if (+this.exportData.dataRange === 0) {
          dataItem = 0;
        } else if (+this.exportData.dataRange === 1 && +this.exportData.dataLanguage === 0) {
          dataItem = 1;
        } else if (+this.exportData.dataRange === 1 && +this.exportData.dataLanguage === 1) {
          dataItem = 2;
        }
        downloadStreamFile(
          'finance/export',
          {
            versionId: this.tableInfo.selectedVersion.id, //63
            dataItem: dataItem, //0
            dataRange: dataRange //0
          },
          this.tableInfo.fundName + '-' + this.tableInfo.selectedTable.name
        ).then(() => {
          this.$emit('confirm', { event: 'export-file' });
        });
      } catch (error) {
        this.$message.error('导出失败');
        this.exportLoading = false;
      }
    },
    exportIr() {
      try {
        this.exportIrLoading = true;
        downloadStreamFile(
          'finance/exportIr',
          {
            versionId: this.tableInfo.selectedVersion.id //versionId
            // type: this.exportIrData.type //0-美元ir; 1-人民币ir
          },
          this.tableInfo.fundName + '-' + this.tableInfo.selectedTable.name + '-ir'
        ).then(() => {
          this.$emit('confirm', { event: 'exportIr-file' });
        });
      } catch (error) {
        this.$message.error('ir导出失败');
        this.exportIrLoading = false;
      }
    },
    /**publish */
    publish() {
      if (this.canPublish) {
        this.$emit('confirm', {
          event: 'publish'
        });
      }
    },
    /**publish */
    /**new forecast */
    newForecast() {
      if (!this.forecastData.name) {
        this.$message.error('请填写预测表名称');
      } else {
        this.$emit('confirm', {
          event: 'new-forecast',
          name: this.forecastData.name
        });
      }
    },
    /**new forecast */
    submitCheckIds(ids) {
      this.newAndRefreshData.receivedIds = ids.join(',');
    },
    switchRefreshFlag(flag) {
      this.newAndRefreshData.refreshLoading = flag;
    },
    /**new table */
    submitNew() {
      if (!this.newAndRefreshData.name) {
        this.$message.error('请填写报表名称');
      } else {
        try {
          this.newFairLoading = true;
          newFair({
            type: this.newAndRefreshData.lastEndDate ? 1 : 0,
            entityId: this.tableInfo.fundId,
            endDate: this.newAndRefreshData.thisEndDate.unix(),
            fairName: this.newAndRefreshData.name,
            listRowId: this.newAndRefreshData.receivedIds.join(',')
          }).then(res => {
            this.newFairLoading = false;
            if (res.code === 200) {
              const data = res.data;
              //可以一试
              // this.$store.commit(
              //   "finance/setMenuId",
              //   this.newAndRefreshData.name + data.fairId
              // );
              this.$emit('confirm', {
                event: 'new-table',
                versionId: data.versionId,
                tableId: data.fairId,
                name: this.newAndRefreshData.name
              });
            }
          });
        } catch (e) {
          console.log(e);
          this.newFairLoading = false;
        }
      }
    },
    /**new table */
    /**refresh table */
    submitRefresh() {
      try {
        if (this.refeshSubmitLoading) {
          return;
        }
        this.refeshSubmitLoading = true;
        let body = {
          versionId: this.tableInfo.selectedVersion.id,
          fairName: this.tableInfo.selectedTable.name
        };
        if (this.tableInfo.fundInfoFlag < 2 && this.tableInfo.allowBack === 0) {
          // 旧版本
          this.newAndRefreshData.receivedIds = this.$refs.refreshCompareData.compareList.filter(item => item.checked).map(item => item.rowId);
          body['listRowId'] = this.newAndRefreshData.receivedIds.join(',');
        } else {
          // 新版本
          body['listRow'] = this.$refs.refreshCompareData.compareList
            .filter(item => item.checked)
            .map(item => {
              return {
                rowIds: item.rowIds,
                changeType: item.changeType
              };
            });
        }
        saveByRefresh(body).then(res => {
          if (res.code === 200) {
            this.$emit('confirm', {
              event: 'refresh-table',
              versionId: this.tableInfo.selectedVersion.id
            });
          }
          this.refeshSubmitLoading = false;
        });
      } catch (e) {
        console.log(e);
        this.refeshSubmitLoading = false;
      }
    },
    /**refresh table */
    /**system check */
    selectFund(item) {
      this.systemCheckData.selectedFund = item;
    },
    submitSystemCheck() {
      if (!this.systemCheckData.selectedFund.id) {
        this.$message.error('请选择基金');
      } else {
        downloadStreamFile(
          'finance/check',
          {
            entityId: this.systemCheckData.selectedFund.id
          },
          this.systemCheckData.selectedFund.name
        );
      }
    },
    /**system check */
    /**rename */
    renameFair() {
      if (!this.renameData.name) {
        this.$message.error('请填写表单名称');
      } else {
        this.$emit('confirm', {
          event: 'rename',
          name: this.renameData.name
        });
      }
    },
    /**rename */
    async getAuditUpdate() {
      try {
        let res = await companyAuditUpdateList({
          fairId: this.tableInfo.selectedTable.id
        });
        this.canPublish = res.code === 200 ? true : false;
        this.dataAudited = res.data.auditedList.map(_ => {
          _.auditTime = _.auditTime ? moment(_.auditTime).format('YYYY-MM-DD') : '';
          return _;
        });
        this.dataUnAudited = res.data.unAuditedList.map(_ => {
          _.auditTime = _.auditTime ? moment(_.auditTime).format('YYYY-MM-DD') : '';
          return _;
        });
      } catch {}
    }
  }
};
</script>
<style lang="less" scoped>
.gap-12 {
  margin-top: 12px;
}
.gap-mix {
  margin: 12px 20px 8px 28px;
}
.dialog {
  .btn-group-antd {
    display: flex;
    justify-content: flex-end;
    button {
      margin-top: 10px;
      margin-left: 10px;
    }
  }
  .btn-group {
    display: flex;
    justify-content: flex-end;
    .btn {
      cursor: pointer;
      margin-top: 10px;
      padding: 3px 12px;
      margin-left: 10px;
      color: #fff;
      background: #1890ff;
      line-height: 22px;
    }
    .disabled {
      cursor: not-allowed;
      background-color: #f5f5f5;
      color: rgba(0, 0, 0, 0.25);
      border: 1px solid #d9d9d9;
    }
  }
  .center-btn {
    cursor: pointer;
    padding: 4px 10px;
    margin: 0 auto;
    background: #1890ff;
    text-align: center;
    color: white;
  }
  .input-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    label {
      min-width: 100px;
    }
  }
  .list {
    display: flex;
    .audited {
      width: 40%;
      /deep/ .ant-table-body {
        overflow: auto !important;
      }
    }
    .unaudited {
      width: 60%;
      margin-left: 48px;
      /deep/ .ant-table-body {
        overflow: auto !important;
      }
      .fund-list {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 13px;
      }
    }
    .audited,
    .unaudited {
      // height: 400px;
      > p {
        margin-top: 8px;
      }
      .hint {
        color: rgba(0, 0, 0, 0.35);
        font-size: 13px;
      }
    }
  }
  @media screen and (max-width: 1440px) {
    .audited,
    .unaudited {
      & /deep/ .ant-table-thead > tr > th {
        padding: 12px 12px;
        overflow-wrap: break-word;
        font-size: 13px;
      }
      & /deep/ .ant-table-tbody > tr > td {
        padding: 12px 12px;
        overflow-wrap: break-word;
        font-size: 13px;
      }

      & /deep/ .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
        background-color: white;
      }
    }
  }

  @media screen and (min-width: 1441px) {
    .audited,
    .unaudited {
      & /deep/ .ant-table-thead > tr > th {
        padding: 12px 12px;
        overflow-wrap: break-word;
        font-size: 14px;
      }
      & /deep/ .ant-table-tbody > tr > td {
        padding: 12px 12px;
        overflow-wrap: break-word;
        font-size: 14px;
      }

      & /deep/ .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
        background-color: white;
      }
    }
  }
}
</style>
